import { AnalyticsBrowser } from "@segment/analytics-next";
import querySegmentWriteKey from "services/querySegmentWriteKey";

export const analytics = new AnalyticsBrowser();
querySegmentWriteKey()
  .then((writeKey) => analytics.load({ writeKey }))
  .catch(console.error);
